import LoginPage from "@/authorization/pages/LoginPage";

const routes = [
  {
    path: "/login",
    component: LoginPage,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/authorization/routes.js